import { DateTime } from 'luxon';
import { WebStorage } from '@backstage/core-app-api';
import { ResponseError } from '@backstage/errors';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const lastSeenKey = "user_last_seen_date";
class AnnouncementsClient {
  constructor(opts) {
    __publicField(this, "discoveryApi");
    __publicField(this, "identityApi");
    __publicField(this, "webStorage");
    __publicField(this, "fetchApi");
    this.discoveryApi = opts.discoveryApi;
    this.identityApi = opts.identityApi;
    this.webStorage = new WebStorage("announcements", opts.errorApi);
    this.fetchApi = opts.fetchApi;
  }
  async fetch(input, init) {
    const baseApiUrl = await this.discoveryApi.getBaseUrl("announcements");
    const { token } = await this.identityApi.getCredentials();
    const headers = new Headers(init == null ? void 0 : init.headers);
    if (token && !headers.has("authorization")) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return this.fetchApi.fetch(`${baseApiUrl}${input}`, {
      ...init,
      headers
    }).then(async (response) => {
      if (!response.ok) {
        throw await ResponseError.fromResponse(response);
      }
      return response.json();
    });
  }
  async delete(input, init) {
    const baseApiUrl = await this.discoveryApi.getBaseUrl("announcements");
    const { token } = await this.identityApi.getCredentials();
    const headers = new Headers(init == null ? void 0 : init.headers);
    if (token && !headers.has("authorization")) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return this.fetchApi.fetch(`${baseApiUrl}${input}`, {
      ...{ method: "DELETE" },
      headers
    }).then(async (response) => {
      if (!response.ok) {
        throw await ResponseError.fromResponse(response);
      }
    });
  }
  async announcements({
    max,
    page,
    category
  }) {
    const params = new URLSearchParams();
    if (category) {
      params.append("category", category);
    }
    if (max) {
      params.append("max", max.toString());
    }
    if (page) {
      params.append("page", page.toString());
    }
    return this.fetch(`/announcements?${params.toString()}`);
  }
  async announcementByID(id) {
    return this.fetch(`/announcements/${id}`);
  }
  async createAnnouncement(request) {
    return await this.fetch(`/announcements`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request)
    });
  }
  async updateAnnouncement(id, request) {
    return this.fetch(`/announcements/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request)
    });
  }
  async deleteAnnouncementByID(id) {
    return this.delete(`/announcements/${id}`, { method: "DELETE" });
  }
  async categories() {
    return this.fetch("/categories");
  }
  async deleteCategory(slug) {
    return this.delete(`/categories/${slug}`, { method: "DELETE" });
  }
  async createCategory(request) {
    await this.fetch(`/categories`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(request)
    });
  }
  lastSeenDate() {
    const lastSeen = this.webStorage.get(lastSeenKey);
    if (!lastSeen) {
      return DateTime.fromISO("1990-01-01");
    }
    return DateTime.fromISO(lastSeen);
  }
  markLastSeenDate(date) {
    this.webStorage.set(lastSeenKey, date.toISO());
  }
}

export { AnnouncementsClient };
//# sourceMappingURL=api.esm.js.map
